import { render } from "./LandingImageLink.vue?vue&type=template&id=0db1b759&scoped=true"
import script from "./LandingImageLink.vue?vue&type=script&lang=js"
export * from "./LandingImageLink.vue?vue&type=script&lang=js"

import "./LandingImageLink.vue?vue&type=style&index=0&id=0db1b759&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db1b759"]])

export default __exports__